/**
 * Portal-scoped department list for "pick a step for this store" dropdowns.
 * Membership: departments.dealerships CSV includes subdomain.
 * Prefer active === true; always include selectedId when present in the source list.
 */
export function departmentsForPortal(departments, subdomain, options = {}) {
	const list = Array.isArray(departments) ? departments : [];
	const portal = (subdomain || '').toString().trim();
	if (!portal) return [];

	const selectedRaw = options.selectedId;
	const selectedId =
		selectedRaw === undefined || selectedRaw === null || selectedRaw === ''
			? null
			: Number(selectedRaw);

	return list.filter((dept) => {
		if (!dept || typeof dept !== 'object') return false;
		const dealers = (dept.dealerships || '').toString().split(',').map(s => s.trim()).filter(Boolean);
		const inPortal = dealers.indexOf(portal) > -1;
		const isActive = dept.active === true || dept.active === 'true' || dept.active === 1;
		const isSelected = selectedId != null && !Number.isNaN(selectedId) && Number(dept.id) === selectedId;
		if (isSelected) return true;
		return inPortal && isActive;
	});
}
